import React, { useState } from 'react';
import { Container, Row, Col, Alert, Spinner } from 'react-bootstrap';
import HeaderTwo from '../../components/HeaderTwo';
import { BreadcrumbBox } from '../../components/common/Breadcrumb';
import FooterTwo from '../../components/FooterTwo';
import { Styles } from './styles/account.js';
import { AUTH_ENDPOINT } from '../../config/api';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState({ type: 'idle', message: '', resetToken: '' });
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!email.trim()) {
            setStatus({ type: 'error', message: 'Please enter your email address.', resetToken: '' });
            return;
        }

        setLoading(true);
        setStatus({ type: 'idle', message: '', resetToken: '' });

        try {
            const response = await fetch(`${AUTH_ENDPOINT}/forgot-password`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email })
            });

            if (!response.ok) {
                const payload = await response.json().catch(() => ({}));
                throw new Error(payload.message || 'Unable to process your request.');
            }

            const payload = await response.json();
            setStatus({
                type: 'success',
                message: payload.message || 'If that account exists, we sent reset instructions to your email.',
                resetToken: payload.resetToken || ''
            });
        } catch (error) {
            setStatus({ type: 'error', message: error.message, resetToken: '' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Styles>
            <div className="main-wrapper login-page">
                <HeaderTwo />
                <BreadcrumbBox title="Forgot Password" />

                <section className="login-area">
                    <Container>
                        <Row>
                            <Col md="12">
                                <div className="login-box">
                                    <div className="login-title text-center">
                                        <h3>Forgot Password</h3>
                                        <p>Enter the email associated with your account and we will send reset instructions.</p>
                                    </div>
                                    {status.type === 'success' && (
                                        <Alert variant="success">
                                            {status.message}
                                            {status.resetToken && (
                                                <div className="mt-2">
                                                    <small>Your reset token (for demo purposes):</small>
                                                    <pre className="reset-token">{status.resetToken}</pre>
                                                </div>
                                            )}
                                        </Alert>
                                    )}
                                    {status.type === 'error' && (
                                        <Alert variant="danger">{status.message}</Alert>
                                    )}
                                    <form className="form" onSubmit={handleSubmit}>
                                        <p className="form-control">
                                            <label htmlFor="forgot_email">Email Address</label>
                                            <input
                                                type="email"
                                                id="forgot_email"
                                                placeholder="name@example.com"
                                                value={email}
                                                onChange={(event) => setEmail(event.target.value)}
                                                disabled={loading}
                                            />
                                        </p>
                                        <button type="submit" disabled={loading}>
                                            {loading ? <Spinner animation="border" size="sm" /> : 'Send Reset Link'}
                                        </button>
                                    </form>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>

                <FooterTwo />
            </div>
        </Styles>
    );
};

export default ForgotPassword;
